<template>
	<div class="text-center settings__container">
		<h1 class="h1 font-weight-bold d-none d-lg-block">{{ $t('Beállítások') }}</h1>
        <div class="h2 text-left d-block d-lg-none">{{$t('Beállítások')}}</div>

		<form @submit.prevent.stop="save()">
			<div class="border-block">
				<h3 class="border-block__title">{{$t('Nyelv')}}</h3>
				<div class="form-group m-0">
					<select
						v-model="UserDTO.langKey"
						v-input-class
						class="input input--small"
						:placeholder="$t('Nyelv')"
					>
						<option value="hu">Magyar</option>
						<option value="en">English</option>
					</select>
				</div>
			</div>

			<div class="border-block">
				<h3 class="border-block__title">{{$t('Személyes adatok')}}</h3>

				<div class="form-group form-group--with-icon">
					<input
						ref="name"
						v-model="$v.UserDTO.name.$model"
						v-input-class
						type="text"
						class="input"
						:placeholder="$t('Név')"
					/>
					<span class="input__icon">
						<img src="@/assets/icons/user.svg" :alt="$t('Név')" />
					</span>
                    <div class="input__error" v-show="$v.UserDTO.name.$error">
                            <span>
                                <img src="@/assets/icons/warning.svg" alt="Hiba" />
                            </span>
                            <span v-if="!$v.UserDTO.name.required">{{$t('A mező kitöltése kötelező!')}}</span>
                        </div>
				</div>

				<div class="form-group form-group--with-icon">
					<input
						ref="email"
						v-model="$v.UserDTO.email.$model"
						v-input-class
						type="email"
						class="input"
						:placeholder="$t('E-mail cím')"
					/>
					<span class="input__icon">
						<img src="@/assets/icons/email.svg" :alt="$t('E-mail cím')" />
					</span>
                    <div class="input__error" v-show="$v.UserDTO.email.$error">
                            <span>
                                <img src="@/assets/icons/warning.svg" alt="Hiba" />
                            </span>
                            <span v-if="!$v.UserDTO.email.required">{{$t('A mező kitöltése kötelező!')}}</span>
                            <span v-else-if="!$v.UserDTO.email.email">{{$t('Hibás e-mail cím!')}}</span>
                        </div>
				</div>

				<div class="form-group form-group--with-icon">
					<input
						ref="tel"
						v-model="$v.UserDTO.phone.$model"
						v-input-class
						type="tel"
						class="input"
						:placeholder="$t('Telefonszám')"
					/>
					<span class="input__icon">
						<img src="@/assets/icons/phone.svg" :alt="$t('Telefonszám')" />
					</span>
                    <div class="input__error" v-show="$v.UserDTO.phone.$error">
                            <span>
                                <img src="@/assets/icons/warning.svg" alt="Hiba" />
                            </span>
                            <span v-if="!$v.UserDTO.phone.required">{{$t('A mező kitöltése kötelező!')}}</span>
                            <span
                                v-else-if="!$v.UserDTO.phone.minLength"
                            >{{$t('A telefonszámnak legalább 8 karakterből kell állnia!')}}</span>
                        </div>
				</div>

				<div class="form-group form-group--checkbox mb-0">
					<div class="checkbox">
						<input
							v-model="UserDTO.useWheelchair"
							type="checkbox"
							id="useWheelchair"
							class="checkbox__input"
						/>
						<label for="useWheelchair" class="checkbox__label"></label>
					</div>

					<label
						for="useWheelchair"
						class="font-weight-bold mb-0"
					>{{ $t('Állandóan kerekesszékkel utazom') }}</label>
				</div>
			</div>

			<div class="border-block">
				<h3 class="border-block__title">{{$t('Jelszó változtatás')}}</h3>

				<div class="form-group form-group--checkbox mb-0">
					<div class="checkbox">
						<input v-model="changePassword" type="checkbox" id="changePassword" class="checkbox__input" />
						<label for="changePassword" class="checkbox__label"></label>
					</div>

					<label for="changePassword">
						<span class="font-weight-bold d-block">{{ $t('Szeretném megváltoztatni a jelszavam') }}</span>
					</label>
				</div>

				<div v-show="changePassword" class="pt-3">
					<div class="form-group form-group--password form-group--with-icon">
						<input
							v-model="$v.PasswordChangeDTO.currentPassword.$model"
							v-input-class
							:type="showCurrentPassword? 'text' : 'password'"
							name="currentPassword"
							class="input"
							:placeholder="$t('Régi jelszó')"
						/>
						<span class="input__icon">
							<img src="@/assets/icons/lock.svg" :alt="$t('Régi jelszó')" />
						</span>
                        <button
                            type="button"
                            @click.prevent.stop="showCurrentPassword = !showCurrentPassword"
                            class="input__show-password"
                        >
                            <inline-svg :src="require('@/assets/icons/eye-crossed.svg')"></inline-svg>
                        </button>
                        <div class="input__error" v-show="$v.PasswordChangeDTO.currentPassword.$error">
                            <span>
                                <img src="@/assets/icons/warning.svg" alt="Hiba" />
                            </span>
                            <span v-if="!$v.PasswordChangeDTO.currentPassword.required">{{$t('A mező kitöltése kötelező!')}}</span>
                        </div>
					</div>

					<div class="form-group form-group--password form-group--with-icon">
						<input
							v-model="$v.PasswordChangeDTO.newPassword.$model"
							v-input-class
							:type="showNewPassword? 'text' : 'password'"
							name="newPassword"
							class="input"
							:placeholder="$t('Új jelszó')"
						/>
						<span class="input__icon">
							<img src="@/assets/icons/lock.svg" :alt="$t('Új jelszó')" />
						</span>
                        <button
                            type="button"
                            @click.prevent.stop="showNewPassword = !showNewPassword"
                            class="input__show-password"
                        >
                            <inline-svg :src="require('@/assets/icons/eye-crossed.svg')"></inline-svg>
                        </button>
                        <div class="input__error" v-show="$v.PasswordChangeDTO.newPassword.$error">
                            <span>
                                <img src="@/assets/icons/warning.svg" alt="Hiba" />
                            </span>
                            <span v-if="!$v.PasswordChangeDTO.newPassword.required">{{$t('A mező kitöltése kötelező!')}}</span>
                            <span v-else-if="!$v.PasswordChangeDTO.newPassword.minLength || !$v.PasswordChangeDTO.newPassword.maxLength"
                            >{{$t('A jelszó minimum 8 és maximum 20 karakter hosszú lehet!')}}</span>
                            <span v-else-if="!$v.PasswordChangeDTO.newPassword.goodPassword"
                            >{{$t('A jelszónak tartalmaznia kell kis betűt, nagy betűt és számot!')}}</span>
                        </div>
					</div>

                    <div>
                        <password v-model="PasswordChangeDTO.newPassword" :secureLength="8" :strength-meter-only="true"/>
                    </div>

					<div class="form-group form-group--password form-group--with-icon mb-0">
						<input
							v-model="$v.newPasswordConfirm.$model"
							v-input-class
							:type="showNewPasswordConfirm? 'text' : 'password'"
							name="newPasswordConfirm"
							class="input"
							:placeholder="$t('Új jelszó ismét')"
						/>
						<span class="input__icon">
							<img src="@/assets/icons/lock.svg" :alt="$t('Új jelszó ismét')" />
						</span>
                        <button
                            type="button"
                            @click.prevent.stop="showNewPasswordConfirm = !showNewPasswordConfirm"
                            class="input__show-password"
                        >
                            <inline-svg :src="require('@/assets/icons/eye-crossed.svg')"></inline-svg>
                        </button>
                        <div class="input__error" v-show="$v.newPasswordConfirm.$error">
                            <span>
                                <img src="@/assets/icons/warning.svg" alt="Hiba" />
                            </span>
                            <span v-if="!$v.newPasswordConfirm.required">{{$t('A mező kitöltése kötelező!')}}</span>
                            <span v-else-if="!$v.newPasswordConfirm.sameAsPassword">{{$t('A beírt jelszavak nem egyeznek!')}}</span>
                        </div>
					</div>
				</div>
			</div>

			<div class="border-block">
				<h3 class="border-block__title">{{$t('Értesítések')}}</h3>

				<div class="form-group form-group--checkbox">
					<div class="checkbox">
						<input
							v-model="UserDTO.getNotifications"
							type="checkbox"
							id="getNotifications"
							class="checkbox__input"
						/>
						<label for="getNotifications" class="checkbox__label"></label>
					</div>

					<label for="getNotifications">
						<span class="font-weight-bold d-block pb-1">{{ $t('E-mail értesítés kérése') }}</span>
						<span
							class="d-block"
						>{{$t('Az e-mail értesítés bekapcsolásával kérheti az igényelt járatok indulása előtti figyelmeztetést a regisztrációkor megadott e-mail címre.')}}</span>
					</label>
				</div>

				<div class="form-group form-group--checkbox mb-0" v-if="UserDTO.getNotifications">
					<label
						for="notifyMinutesBefore"
						class="font-weight-bold pb-1"
					>{{$t('Értesítés kérése indulás előtt (perc)')}}</label>
					<div class="form-group m-0">
						<select
							v-model="UserDTO.notifyMinutesBefore"
							style="width: 85px"
							v-input-class
							class="input input--small"
							id="notifyMinutesBefore"
							:placeholder="$t('Perc')"
						>
							<option :value="val" v-for="val in notifyTimes" :key="val">{{val}}</option>
						</select>
					</div>
				</div>
			</div>

			<div class="text-left pb-4">
				<a href="#" @click="deleteAccount()" class="link-blue">{{$t('Fiók törlése')}}</a>
			</div>

			<div class="text-left">
				<button
					type="submit"
					class="button button--blue w-lg-auto"
					style="min-width:160px; width:100%"
                    :disabled="isFormInvalid"
				>{{$t('Mentés')}}</button>
			</div>
		</form>
	</div>
</template>

<script>
import { PasswordChangeDTO, UserDTO } from "@/models";
import {
	changePasswordUsingPOST,
    saveAccountUsingPOST,
    deleteAccountUsingDELETE,
	getAccountUsingGET,
} from "@/api";
import Cookies from 'js-cookie'
import Password from '@/components/PasswordStrengthMeter.vue'
import {
    required,
    email,
	maxLength,
	minLength,
	sameAs,
} from "vuelidate/lib/validators";

let notifyTimes = []
for(let i = 5; i <= 120; i++){
    if(i%5 === 0)
    notifyTimes.push(i);
}

export default {
    name: "Settings",
    components: { Password },
	data() {
		return {
            showCurrentPassword: false,
            showNewPassword: false,
            showNewPasswordConfirm: false,
			UserDTO: new UserDTO(),
			PasswordChangeDTO: new PasswordChangeDTO(),
			newPasswordConfirm: null,
            changePassword: false,
            notifyTimes:notifyTimes
		};
    },
    validations: {
        UserDTO: {
            email: {
				required,
				email,
			},
			phone: {
				required,
				minLength: minLength(10),
				maxLength: maxLength(20),
			},
			name: {
				required,
			}
        },
		PasswordChangeDTO: {
            currentPassword: {
                required: function(val) {
                    return this.changePassword;
                }
			},
			newPassword: {
                required: function(val) {
                    return this.changePassword;
                },
				minLength: minLength(8),
                maxLength: maxLength(100),
                goodPassword:(password) => {
                    return /[a-z]/.test(password) &&
                    /[A-Z]/.test(password) &&
                    /[0-9]/.test(password)
                }
			},
		},
		newPasswordConfirm: {
			required,
			sameAsPassword: sameAs(function () {
				return this.PasswordChangeDTO.newPassword;
			}),
        }
    },
    computed: {
        isFormInvalid: function() {
            if(this.$v.UserDTO.$invalid){
                return true;
            } else {
                if(this.changePassword) {
                    if(this.$v.PasswordChangeDTO.$invalid || this.$v.newPasswordConfirm.$invalid){
                        return true;
                    }
                }
            }
            return false;
        }
    },
	methods: {
        saveAccount: function() {
            saveAccountUsingPOST({ userDto: this.UserDTO })
				.then((response) => {
					if (response.status === 200) {
                        if(this.UserDTO.langKey !== this.$i18n.locale) {
                            this.$i18n.locale = this.UserDTO.langKey;
                            Cookies.set('langKey',this.UserDTO.langKey, { expires: 365 });
                        }
						this.$swal({
							title: this.$t("Sikeres mentés"),
							text: this.$t("Fiók adatait módosítottuk."),
							imageUrl: window.swalSuccess,
						});
					}
				})
				.catch((err) => {
                    this.$swal({
                            title: this.$t("Beállítások"),
                            text: err.errorMessage,
                            imageUrl: window.swalError,
                        });
					console.warn(err);
				});
        },
		save: function () {
			if (this.changePassword) {
				if (!this.PasswordChangeDTO.currentPassword) {
					return this.$swal({
						title: this.$t("Jelszó módosítás"),
						text: this.$t("A régi jelszó mező üres!"),
						imageUrl: window.swalError,
					});
				} else if (!this.PasswordChangeDTO.newPassword) {
					return this.$swal({
						title: this.$t("Jelszó módosítás"),
						text: this.$t("Az új jelszó mező üres!"),
						imageUrl: window.swalError,
					});
				} else if (!this.newPasswordConfirm) {
					return this.$swal({
						title: this.$t("Jelszó módosítás"),
						text: this.$t("Az új jelszó ismét mező üres!"),
						imageUrl: window.swalError,
					});
				}

				if (
					this.newPasswordConfirm !==
					this.PasswordChangeDTO.newPassword
				) {
					return this.$swal({
						title: this.$t("Jelszó módosítás"),
						text: this.$t("A beírt jelszavak nem egyeznek!"),
						imageUrl: window.swalError,
					});
				}

				changePasswordUsingPOST({
					passwordChangeDto: this.PasswordChangeDTO,
				}).then((response)=> {
                    if(response.status === 200) {
                        this.changePassword = false;
                        this.PasswordChangeDTO.currentPassword = null;
                        this.PasswordChangeDTO.newPassword = null;
                        this.newPasswordConfirm = null;
                    }
                    this.saveAccount();
                }).catch((err) => {
                    this.$swal({
                            title: this.$t("Jelszó módosítás"),
                            text: err.errorMessage,
                            imageUrl: window.swalError,
                        });
					console.warn(err);
				});
			} else {
                this.saveAccount();
            }
		},
		deleteAccount() {

            this.$swal({
				title: this.$t("Fiók törlése"),
				text: this.$t("Biztosan törlöd a fiókodat? Később nem állítható vissza!"),
                imageUrl: window.swalError,
                confirmButtonText: this.$t('Törlés'),
                cancelButtonText: this.$t('Mégse'),
                showCancelButton: true,
                customClass: {
                    confirmButton: 'button button--red button--swal',
                    cancelButton: 'button button--swal',
                    title: 'text-biggest font-weight-bold',
                    actions: 'swal2-confirm-actions'
                }
			}).then((result)=> {
                if(result.value) {
                    deleteAccountUsingDELETE()
					.then((response) => {
						this.$store.commit("logout");
							this.$swal({
								title: this.$t("Fiók törlése"),
								text: this.$t("Fiók adatait töröltük és ezennel kijelentkeztetjük az oldalról."),
								imageUrl: window.swalSuccess,
							}).then(() => {
								this.$router.push({ name: "login" });
							});
					})
					.catch((err) => {
                        this.$swal({
                            title: this.$t("Fiók törlése"),
                            text: err.errorMessage,
                            imageUrl: window.swalError,
                        });
						console.warn(err);
					});
                }
            });
		},
	},
	created() {
		getAccountUsingGET()
			.then((response) => {
				if (response.status === 200) {
                    this.$set(this, "UserDTO", response.data);
                    
                    if(!Cookies.get('langKey')) {
                        Cookies.set('langKey',response.data.langKey, { expires: 365 });
                    }
				}
			})
			.catch((err) => {
                this.$swal({
                            title: this.$t("Beállítások"),
                            text: err.errorMessage,
                            imageUrl: window.swalError,
                        });
				console.warn(err);
			});
	},
};
</script>

<style lang="scss" scoped>
.settings__container {
	width: 100%;
	max-width: 540px;
	margin: 0 auto;
}
.input__show-password {
    .svg-fill {
        fill: #333333;
    }
}
.input__icon {
    .svg-fill {
        fill: #CDCDCD;
    }
}
</style>